module.exports = __webpack_public_path__ + "img/skillers_logo_2x_mini.d56088f6.png";